import Store from '../../components/store';
const index = () => {
  return <Store />;
};

export default index;
